// packages/viewer/src/listenerViewer/styles.ts
import { css } from "lit";
import { icons } from "../styles/icons";

export const styles = css`
    ${icons}
    :host {
        display: flex;
        flex-direction: column;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
        font-size: 14px;
        line-height: 1.5;
        color: var(--fe-color-text, #333);
        background: var(--fe-color-bg, #fff);
        overflow: hidden;
        position: relative;
    }

    :host([dark]) {
        --fe-color-text: rgba(255, 255, 255, 0.85);
        --fe-color-bg: #1f1f1f;
        --fe-color-border: #303030;
        --fe-color-header-bg: #141414;
        --fe-color-hover: rgba(255, 255, 255, 0.08);
        --fe-color-text-secondary: rgba(255, 255, 255, 0.45);
        --fe-color-bg-secondary: rgba(255, 255, 255, 0.05);
        --fe-color-tag-bg: rgba(255, 255, 255, 0.08);
        --fe-color-tag-text: rgba(255, 255, 255, 0.85);
        --fe-left-width: 33.33%;
    }

    :host {
        --fe-left-width: 30%;
    }

    .toolbar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0.75em 1em;
        border-bottom: 1px solid var(--fe-color-border, #e8e8e8);
        background: var(--fe-color-header-bg, #fff);
    }

    .toolbar-title {
        font-size: 14px;
        /* font-weight: 600;
        color: var(--fe-color-text, #333); */
    }

    .main-container {
        display: flex;
        flex: 1;
        overflow: hidden;
        position: relative;
    }

    .tree-panel {
        flex: 0 0 var(--fe-left-width, 33.33%);
        overflow-y: auto;
        overflow-x: hidden;
        border-right: 1px solid var(--fe-color-border, #e8e8e8);
        padding: 8px;
    }

    .tree-panel::-webkit-scrollbar {
        width: 2px;
    }
    .tree-panel::-webkit-scrollbar-thumb {
        background: transparent;
    }
    .tree-panel:hover::-webkit-scrollbar-thumb {
        background: rgba(0, 0, 0, 0.2);
    }

    .listeners-panel {
        flex: 1;
        overflow-y: auto;
        overflow-x: hidden;
        padding: 8px;
        padding-left: 0px;
    }

    .listeners-panel::-webkit-scrollbar {
        width: 2px;
    }
    .listeners-panel::-webkit-scrollbar-thumb {
        background: transparent;
    }
    .listeners-panel:hover::-webkit-scrollbar-thumb {
        background: rgba(0, 0, 0, 0.2);
    }

    .resizer {
        width: 8px;
        cursor: col-resize;
        background: transparent;
        position: relative;
        z-index: 10;
        flex-shrink: 0;
        user-select: none;
    }

    .resizer::after {
        content: "";
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 4px;
        height: 40px;
        background: var(--fe-color-border, #e8e8e8);
        border-radius: 2px;
        opacity: 0;
        transition:
            opacity 0.2s,
            height 0.2s;
    }

    .resizer:hover::after {
        opacity: 1;
        background: #1890ff;
    }

    .resizer.dragging::after {
        opacity: 1;
        background: #1890ff;
        height: 60px;
    }

    .empty-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 3em;
        padding-left: 0;
        color: var(--fe-color-text-secondary, #999);
        text-align: center;
    }

    .btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        padding: 0.4em 0.8em;
        border: none;
        border-radius: 4px;
        background: transparent;
        color: var(--fe-color-text, #333);
        font-size: 13px;
        cursor: pointer;
        transition: all 0.3s;
        user-select: none;
    }

    .btn:hover {
        color: #1890ff;
        background: rgba(24, 144, 255, 0.06);
    }

    .btn-icon {
        padding: 0.2em;
        width: 24px;
        height: 24px;
    }

    .tag {
        display: inline-flex;
        align-items: center;
        padding: 0.1em 0.4em;
        border-radius: 5px;
        font-size: 11px;
        white-space: nowrap;
        background: var(--fe-color-tag-bg, #f0f0f0);
        color: var(--fe-color-tag-text, #666);
    }

    .tree-node {
        display: flex;
        align-items: center;
        padding: 4px 8px;
        cursor: pointer;
        border-radius: 4px;
        transition: background 0.2s;
        user-select: none;
    }

    .tree-node:hover {
        background: var(--fe-color-hover, #fafafa);
    }

    .tree-node.selected {
        background: rgba(24, 144, 255, 0.1);
    }

    .tree-node-toggle {
        width: 16px;
        height: 16px;
        margin-right: 4px;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        transition: transform 0.2s;
    }

    .tree-node-toggle.expanded {
        transform: rotate(90deg);
    }

    .tree-node-toggle.hidden {
        visibility: hidden;
    }

    .tree-node-content {
        display: flex;
        align-items: center;
        gap: 6px;
        flex: 1;
    }

    .tree-node-label {
        font-family: "SFMono-Regular", Consolas, monospace;
        font-size: 13px;
        flex-grow: 1;
    }

    .tree-node-badge {
        background: var(--fe-color-tag-bg, #f0f0f0);
        color: var(--fe-color-tag-text, #666);
        padding: 2px 6px;
        border-radius: 8px;
        font-size: 11px;
    }

    .tree-children {
        padding-left: 16px;
    }

    .tag {
        display: inline-flex;
        align-items: center;
        padding: 0.1em 0.4em;
        border-radius: 5px;
        font-size: 11px;
        white-space: nowrap;
        background: var(--fe-color-tag-bg, #f0f0f0);
        color: var(--fe-color-tag-text, #666);
    }

    /* 保留消息卡片样式 */
    .retained-message-card {
        margin-bottom: 12px;
        border-radius: 6px;
        border: 1px solid #ffa39e;
        background: #fff1f0;
        overflow: hidden;
        transition: all 0.2s;
    }

    .retained-message-card:hover {
        box-shadow: 0 2px 8px rgba(255, 77, 79, 0.15);
    }

    .retained-message-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 8px 12px;
        background: rgba(255, 77, 79, 0.1);
        border-bottom: 1px solid #ffa39e;
    }

    .retained-message-title {
        flex: 1;
        font-size: 13px;
        font-weight: 500;
        color: #ff4d4f;
    }

    .retained-message-actions {
        display: flex;
        gap: 4px;
    }

    .retained-message-content {
        padding: 4px;
    }

    .retained-message-text {
        margin: 0;
        padding: 8px;
        background: rgba(255, 255, 255, 0.6);
        border-radius: 4px;
        font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
        font-size: 12px;
        line-height: 1.5;
        color: #262626;
        overflow-x: auto;
        white-space: pre-wrap;
        word-break: break-all;
    }

    /* 暗黑模式下的保留消息卡片 */
    .retained-message-card.dark,
    :host([dark]) .retained-message-card {
        border: 1px solid rgba(255, 77, 79, 0.4);
        background: rgba(255, 77, 79, 0.08);
    }

    .retained-message-card.dark:hover,
    :host([dark]) .retained-message-card:hover {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    }

    .retained-message-card.dark .retained-message-header,
    :host([dark]) .retained-message-header {
        background: rgba(255, 77, 79, 0.15);
        border-bottom: 1px solid rgba(255, 77, 79, 0.3);
    }

    .retained-message-card.dark .retained-message-title,
    :host([dark]) .retained-message-title {
        color: #ff7875;
    }

    .retained-message-card.dark .retained-message-text,
    :host([dark]) .retained-message-text {
        background: rgba(0, 0, 0, 0.2);
        color: rgba(255, 255, 255, 0.85);
    }

    @media (max-width: 568px) {
        .main-container {
            flex-direction: column;
        }

        .tree-panel {
            flex: 0 0 40%;
            border-right: none;
            border-bottom: 1px solid var(--fe-color-border, #e8e8e8);
        }

        .resizer {
            display: none;
        }
    }
`;
